import { Base64 } from 'js-base64';
import _ from 'lodash';
import cookie from 'react-cookies';
import uuid from 'uuid/v1';
import Constants from '../../../common/Constants';
import { RoundRobinOption, WAGER_STATUS, WinRiskType, BetslipSelectionType, WagerMyBetMap, BetType, SPORT_GROUP, SportGroup } from '../../../common/Foundation';
import Utils from '../../../common/Utils';
import AlertComponentAction from '../../BaseComponent/AlertComponent/AlertComponentAction';
import BetslipAction from '../BetslipAction';
import ToastGeneratorAction from '../../BaseComponent/ToastGeneratorComponent/ToastGeneratorAction';
import { toJS } from 'mobx';
import { EVENT } from '../../../common/events/listEvents';
import i18next from 'i18next';

export default class MbAsiaBetslipActions {
  static initStores(betslipStore, sportsStore) {
    this.BetslipStore = betslipStore
    this.SportsStore = sportsStore
  }

  static initTranslation(translate) {
    this.translate = translate
  }

  static invalidOddsFormatHandle() {
    this.BetslipStore.displayAsiaBetslip(false)
    this.BetslipStore.updateBetslipReadyState(false)
    AlertComponentAction.openAlertCallBack(
      i18next.t(`errors:${Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT}`),
      () => { this.updateMaxBetPreferenceSettingBase() }, 'alert-invalid-odds-format',
      i18next.t('Selection unavailable'), false);
  }

  static internalErrorHandle() {
    this.BetslipStore.displayAsiaBetslip(false)
    this.BetslipStore.updateBetslipReadyState(false)
    AlertComponentAction.openAlert(i18next.t(`errors:${Constants.TOAST.ERROR_MESSAGES}`))
  }

  static updateMaxBetPreferenceSettingBase() {
    window.fireEvent(EVENT.UPDATE_MAX_BET_PREFERENCE_SETTING_BASE);
  }

  static getOutrightSelectionInfo(isRefresh, originalOdds) {
    const { selection, id, odds, isSimplifiedBet } = this.BetslipStore.asiaOutrightSelection
    const { isReuseSelection, isReady } = this.BetslipStore;
    const { oddsFormat } = this.SportsStore.options
    const oddsSelections = [
      {
        selectionId: selection,
        oddsId: id,
        oddsSelectionsType: BetslipSelectionType.OUTRIGHT,
      }
    ];
    if (_.isEmpty(this.BetslipStore.asiaOutrightReuseSelection)) {
      this.BetslipStore.setAsiaReuseOutrightSelection(this.BetslipStore.asiaOutrightSelection);
    }
    let payload = BetslipAction.buildNormalBetSelectionPayload(oddsSelections, oddsFormat)
    if (!isReady || isRefresh) {
    BetslipAction.getAllOddsSelection(payload).then(response => {
      if (response) {
        let res = response[0]
        if (res.status == WAGER_STATUS.UNAVAILABLE) {
          let msg = this.translate('errors:' + Constants.UNAVAILABLE_MESSAGE)
          AlertComponentAction.openAlert(msg)
          this.BetslipStore.displayAsiaBetslip(false)
          this.BetslipStore.updateBetslipReadyState(false)
        } 
        /**
          *  Max Bet Reference BASE
          *  CASE: Agent setting => In-session User click Outright Odds
          * 
          * */
        else if (response[0] && Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT === response[0].status) {
          this.invalidOddsFormatHandle();
        } else {
          this.BetslipStore.updateBetslipReadyState(true)
          MbAsiaBetslipActions.initSingleDefaultStake(isRefresh)

          let currentOdds = isRefresh && originalOdds ? originalOdds : odds
          
          // ignore odds change message for simplified bet
          if (!isSimplifiedBet && (
              res.status == WAGER_STATUS.ODDS_CHANGE && res.odds != currentOdds
          )) {
            let msg = this.translate("errors:" + Constants.ODDS_CHANGED_MESSAGE)
              .replace("{0}", Utils.formatOddsValue(currentOdds, oddsFormat))
              .replace("{1}", Utils.formatOddsValue(res.odds, oddsFormat))
      
            AlertComponentAction.openAlert(msg)
          }
          if (isReuseSelection) {
            MbAsiaBetslipActions.clearReuseSelection();
          }
        }
        this.BetslipStore.updateAsiaOutrightBetItem(res)
      }
    });
   }
  }

  static handleSingleOddsChange(newOdds) {
    this.BetslipStore.setAsiaSingleSelection({
      ...this.BetslipStore.asiaSingleSelection, 
      odds: newOdds
    });
    this.BetslipStore.setAsiaReuseSingleSelection({
      ...this.BetslipStore.asiaReuseSingleSelection, 
      odds: newOdds
    });
  }
  
  static getSingleSelectionInfo(isRefresh, originalOdds) {
    const {selection, id, odds, isSimplifiedBet} = this.BetslipStore.asiaSingleSelection;
    const {isReuseSelection, isReady} = this.BetslipStore;
    const {oddsFormat} = this.SportsStore.options
    const oddsSelections = [
      {
        selectionId: selection,
        oddsId: id,
        oddsSelectionsType: BetslipSelectionType.NORMAL,
      }
    ]
    if (_.isEmpty(this.BetslipStore.asiaReuseSingleSelection)) {
      this.BetslipStore.setAsiaReuseSingleSelection(this.BetslipStore.asiaSingleSelection);
    }
    let payload = BetslipAction.buildNormalBetSelectionPayload(oddsSelections, oddsFormat);
    if (isReady && !isRefresh) {
      return
    }
    BetslipAction.getAllOddsSelection(payload).then(response => {
      if (!response || !response.length) {
        this.internalErrorHandle();
        return
      }
      if (response.error) {
        AlertComponentAction.openAlert(this.translate('errors:' + response.error));
        return;
      }
      let data = response[0]
      switch (data.status) {
        case Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT: {
          this.invalidOddsFormatHandle();
          break;
        }
        case Constants.UNAVAILABLE:
        case Constants.INVALID_BET_ACCEPTANCE_TYPE: {
          let msgKey = BetslipAction.getKeyMessage(data.status);
          let msg = this.translate('errors:' + msgKey);
          AlertComponentAction.openAlert(msg)
          this.BetslipStore.displayAsiaBetslip(false)
          this.BetslipStore.updateBetslipReadyState(false)
          break;
        }
        default: {
          this.BetslipStore.updateBetslipReadyState(true);
          MbAsiaBetslipActions.initSingleDefaultStake(isRefresh);
          const currentOdds = isRefresh && originalOdds ? originalOdds : odds
          // ignore odds change message for simplified bet
          if ((!isSimplifiedBet || isReuseSelection) && (
              data.status === WAGER_STATUS.ODDS_CHANGE && currentOdds != data.odds
          )) {
            let msg = this.translate("errors:" + Constants.ODDS_CHANGED_MESSAGE)
                .replace("{0}", Utils.formatOddsValue(currentOdds, oddsFormat))
                .replace("{1}", Utils.formatOddsValue(data.odds, oddsFormat))
            AlertComponentAction.openAlert(msg, 'asia_betslip_alert', false, () => this.handleSingleOddsChange(data.odds));
          }
          if (isReuseSelection) {
            MbAsiaBetslipActions.clearReuseSelection();
          }
        }
      }
      this.BetslipStore.updateAsiaNormalBetItem(data);
    });
  }

  static getTeaserSelectionInfo(removedLegId) {
    const { oddsSelections, asiaTeaserSelections, asiaTeaserTicket, isReady, isReuseSelection } = this.BetslipStore;    
    const { oddsFormat } = this.SportsStore.options    
    let isRemove = asiaTeaserTicket && asiaTeaserTicket.legs && asiaTeaserTicket.legs.length > asiaTeaserSelections.length;
    if (_.isEmpty(this.BetslipStore.asiaTeaserReuseSelections) || isRemove) {
      this.BetslipStore.setAsiaTeaserReuseSelections(this.BetslipStore.asiaTeaserSelections);
    }
    if (isRemove) {
      let deletePayload = { legId: removedLegId, oddsFormat, teaserId: asiaTeaserTicket.teaserId, ticketId: asiaTeaserTicket.ticketId }
      BetslipAction.removeTeaserTicket(deletePayload).then(res => {
        if (res) {
          if (res.error) {
            AlertComponentAction.openAlertCallBack(
              this.translate('errors:' + res.error),
                () => AlertComponentAction.closeAlert()
              )
            } else {
              MbAsiaBetslipActions.initTeaserDefaultStake()
              this.mergeTeaserSelection(oddsSelections, res)
              this.BetslipStore.updateAsiaTeaserTicket(res)
            }
          }
        })
      } else if (!isReady) {
        let _teaserId
        if(asiaTeaserSelections && asiaTeaserSelections.length > 0){
          const arr = asiaTeaserSelections[0].id.split('|')
          _teaserId = _.last(arr)
        }
        let newAsiaTeaserSelections = [];
        _.forEach(asiaTeaserSelections, sel => {
            newAsiaTeaserSelections.push({
              id: sel.id, 
              legId: uuid(), 
              selection: sel.selection, 
              odds: sel.odds 
            })
        })
        let payload = MbAsiaBetslipActions.buildAsiaTeaserBetSelectionPayload(newAsiaTeaserSelections, oddsFormat, _teaserId,  asiaTeaserTicket.ticketId)
        this.BetslipStore.updateTeaserBetPayload(payload);
        BetslipAction.getTeaserOddsSelection(payload).then(res => {
          if (res) {
            if (res.error) {
              AlertComponentAction.openAlertCallBack(
                this.translate('errors:' + res.error),
                () => AlertComponentAction.closeAlert()
              )
              this.BetslipStore.displayAsiaBetslip(false)
              this.BetslipStore.updateBetslipReadyState(false)
            } else {
              this.BetslipStore.updateBetslipReadyState(true)
              this.mergeTeaserSelection(oddsSelections, res)
              MbAsiaBetslipActions.initTeaserDefaultStake()
              if (isReuseSelection) {
                MbAsiaBetslipActions.clearReuseSelection();
              }
            }
            this.BetslipStore.setAsiaTeaserSelections(newAsiaTeaserSelections);
            this.BetslipStore.updateAsiaTeaserTicket(res);
          }
        })
    }
  }

  static mergeTeaserSelection(oddsSelections, teaserTicket) {
    const { 
      teaserBetPayload,
      teaserBetItems
    } = this.BetslipStore;

    _.forEach(teaserTicket.legs, leg => {
      const legId = leg.legId;
      const payloadLegs = JSON.parse(teaserBetPayload.legs);
      const idx = this.getIndexInArrayByNameAndValue(payloadLegs, 'legId', legId);
      const selectionId = payloadLegs[idx].selectionId;
      const extraInfo = oddsSelections.reduce((filtered, selection) => {
        
        if (selection.selectionId === selectionId) {
          filtered.push({
            homeTeam: selection.homeTeam,
            awayTeam: selection.awayTeam,
            selectionType: selection.selectionType,
            leagueName: selection.leagueName,
            sportName: selection.sportName,
            teaserType: selection.teaserType,
            sportId: selection.sportId,
            selectionId: selection.selectionId,
            eventTeamType: selection.eventTeamType
          })
        }
        return filtered;
      }, [])
      if (extraInfo.length > 0) {
        Object.assign(leg, extraInfo[0]);
      }

      if (leg.pointStatus === Constants.TEASER_ERROR.POINT_CHANGE) {
        const indexPayload = BetslipAction.getIndexInArrayByNameAndValue(payloadLegs, 'legId', leg.legId);
        if (indexPayload > -1) {
          const indexSelection = BetslipAction.getIndexInArrayByNameAndValue(oddsSelections, 'selectionId', payloadLegs[indexPayload].selectionId);
          const newSelectionId = leg.lineId + '|' + oddsSelections[indexSelection].oddsId + '|' + oddsSelections[indexSelection].teamType + '|' + leg.point;
          this.BetslipStore.updateTeaserOddSelectionId(indexSelection, newSelectionId);
          this.BetslipStore.updateTeaserPayloadSelectionId(indexPayload, newSelectionId);
          Object.assign(leg, {errorCode: Constants.TEASER_ERROR.SELECTION_POINT_CHANGED});
        }
      }
      if (leg.errorCode === Constants.TEASER_ERROR.POINTS_NO_LONGER_AVAILABLE || leg.errorCode === Constants.TEASER_ERROR.EVENT_NOT_FOUND) {
        Object.assign(leg, {errorCode: Constants.TEASER_ERROR.EVENT_NOT_FOUND});
      }
    });
    if (!teaserTicket.maxLegs && !teaserTicket.minLegs) {
        const minMaxLegs = { 
        minLegs: teaserBetItems.minLegs,
        maxLegs: teaserBetItems.maxLegs,
        };
        Object.assign(teaserTicket, minMaxLegs);
    }
    this.BetslipStore.setTeaserBetItems(teaserTicket);
  }

  static getIndexInArrayByNameAndValue(arr, idName, idValue) {
    return  _.findIndex(arr, item  => {return item[idName] === idValue });
  }

  static getParlaySelectionInfo(isRefresh, removedLegId) {
    const { asiaParlaySelections, asiaParlayTicket, isReady, isReuseSelection } = this.BetslipStore;
    const { oddsFormat } = this.SportsStore.options;
    let isRemove = asiaParlayTicket && asiaParlayTicket.legs && asiaParlayTicket.legs.length > asiaParlaySelections.length;
    if (_.isEmpty(this.BetslipStore.asiaReuseParlaySelections) || isRemove) {
      this.BetslipStore.setAsiaReuseParlaySelections(this.BetslipStore.asiaParlaySelections);
    }
    if (isRemove) {
      let deletePayload = MbAsiaBetslipActions.buildAsiaParlayBetSelectionPayload(asiaParlaySelections, oddsFormat, asiaParlayTicket.ticketId)
      BetslipAction.removeParlayBetSelection(deletePayload, removedLegId).then(res => {
        if (res) {
          if (res.error) {
            AlertComponentAction.openAlertCallBack(
              this.translate('errors:' + res.error),
              () => AlertComponentAction.closeAlert()
            )
          } else {
            this.BetslipStore.updateAsiaParlayTicket(res)
            MbAsiaBetslipActions.initParlayDefaultStake();
          }
        }
      })
    } else if (!isReady || isRefresh) {
      let payload = MbAsiaBetslipActions.buildAsiaParlayBetSelectionPayload(asiaParlaySelections, oddsFormat);
      BetslipAction.getParlayOddsSelection(payload).then(res => {
        if (res) {
          if (res.error) {
            AlertComponentAction.openAlertCallBack(
              this.translate('errors:' + res.error),
              () => AlertComponentAction.closeAlert()
            )
            this.BetslipStore.displayAsiaBetslip(false)
            this.BetslipStore.updateBetslipReadyState(false)
          } else {
            this.BetslipStore.updateBetslipReadyState(true);
            if (!isRefresh) {
              MbAsiaBetslipActions.initParlayDefaultStake();
              if (isReuseSelection) {
                MbAsiaBetslipActions.clearReuseSelection();
              }
            }
          }
          this.BetslipStore.updateAsiaParlayTicket(res);
          oddsFormat !== this.SportsStore.getPreviousOddsFormat && this.updateOddsByOddsFormat(oddsFormat, asiaParlaySelections, res.legs, true, this.BetslipStore, this.SportsStore);
        }
      });
    }
  }

  static clearReuseSelection() {
    const betslipBetType = this.BetslipStore.asiaActiveBetslip;
    this.BetslipStore.updateIsFirstTimeBet(false);
    this.BetslipStore.updateIsReuseSelection(false);
    switch (betslipBetType) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        this.BetslipStore.setAsiaReuseSingleSelection({});
        break;
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        this.BetslipStore.setAsiaReuseParlaySelections({});
        break;
      case Constants.ASIA_BETSLIP_TYPES.TEASER:
        this.BetslipStore.setAsiaTeaserReuseSelections({});
        break;
      case Constants.ASIA_BETSLIP_TYPES.OUTRIGHT:
        this.BetslipStore.setAsiaReuseOutrightSelection({});
        break;
      default:
        return;
    }
  }

  static initSingleDefaultStake(isRefresh) {
    const {defaultStake, enableDefaultStake, acceptBetterOdds} = this.SportsStore.options;
    const {isReuseSelection, asiaSingleData} = this.BetslipStore;
    if (!isRefresh) {
      // init default acceptBetterOdds based on User Settings
      this.BetslipStore.updateAsiaSingleData('outRightAcceptBetterOdds', acceptBetterOdds)
      this.BetslipStore.updateAsiaSingleData('normalAcceptBetterOdds', acceptBetterOdds)

      let stake = isReuseSelection ? asiaSingleData.stake : '';
      if (enableDefaultStake && defaultStake) {
        stake = defaultStake
      }
      
      this.BetslipStore.updateAsiaSingleData('stake', stake)
      this.BetslipStore.changeWinRiskOption(WinRiskType.BASE)
    }
  }

  static initParlayDefaultStake() {
    const {defaultStake, enableDefaultStake} = this.SportsStore.options;
    const {isReuseSelection, initStakeReuse} = this.BetslipStore;
    if (enableDefaultStake && defaultStake) {
      this.BetslipStore.setAsiaParlayData({ stake: defaultStake, selectedRoundRobins: [RoundRobinOption.PARLAY] });
    } else {
      this.BetslipStore.setAsiaParlayData({ stake: isReuseSelection ? initStakeReuse : '', selectedRoundRobins: [RoundRobinOption.PARLAY] });
    }
  }

  static initTeaserDefaultStake() {
    const { defaultStake, enableDefaultStake } = this.SportsStore.options;
    const { isReuseSelection, asiaTeaserData } = this.BetslipStore;
    if (enableDefaultStake && defaultStake) {
      this.BetslipStore.setAsiaTeaserData({ stake: defaultStake });
    } else {
      this.BetslipStore.setAsiaTeaserData({ stake: isReuseSelection ? asiaTeaserData.stake : '' });
    }
 }

  static addTeaserSelection(teaserSelection, legId) {
    let selections = Object.assign([], toJS(this.BetslipStore.asiaTeaserSelections));
    const isExistingEvents = _.find(this.BetslipStore.asiaTeaserSelections, sel => sel.id === teaserSelection.oddsId);

    // check here
    if (isExistingEvents) {      
      selections = _.filter(selections, sel => sel.id !== teaserSelection.oddsId);      
    }
    
    selections.push({ id: teaserSelection.oddsId, legId: legId || uuid(), selection: teaserSelection.selectionId, odds: teaserSelection.odds })
    this.BetslipStore.setAsiaTeaserSelections(selections);
    this.BetslipStore.addOddsSelections(teaserSelection);
    this.BetslipStore.addOddsReuseSelections(teaserSelection);
    this.BetslipStore.setAsiaTeaserReuseSelections(
      this.BetslipStore.isFirstTimeBet
        ? [...selections, ...this.BetslipStore.asiaTeaserReuseSelections]
        : selections);
  }


  static addParlaySelection(id, selection, odds, plRes) {
    let selections = Object.assign([], toJS(this.BetslipStore.asiaParlaySelections));
    const eventId = id.split('|')[0];
    const isExistingEvents = _.find(this.BetslipStore.asiaParlaySelections, sel => sel.id.split('|')[0] == eventId);
    if (isExistingEvents) {
      // allow 2 leg on 1 event
      if (plRes == Constants.SUPPORT_PARLAY.ALLOWED_WITHOUT_RESTRICTIONS) {
        const tmp = _.filter(selections, sel => sel.id.split('|')[0] == eventId);
        const betType = id.split('|')[2];
        // remove the event has the same bet type
        const removeIdx = _.findIndex(tmp, sel => { return sel.id.split('|')[2] == betType; });
        if (removeIdx > -1) {
          selections = _.filter(selections, sel => sel.id !== tmp[removeIdx].id);
        }
      } else {
        selections = _.filter(selections, sel => sel.id.split('|')[0] !== eventId);
      }
    }

    selections.push({ id: id, legId: uuid(), selection: selection, odds: odds });
    this.BetslipStore.setAsiaParlaySelections(selections);
    this.BetslipStore.setAsiaReuseParlaySelections(
      this.BetslipStore.isFirstTimeBet
        ? [...selections, ...this.BetslipStore.asiaReuseParlaySelections]
        : selections);
  }

  static refreshParlaySelections() {
    const { asiaParlaySelections } = this.BetslipStore

    let refreshedSelections = asiaParlaySelections.map(sel => {
      sel.legId = uuid();
      return sel;
    })

    this.BetslipStore.setAsiaParlaySelections(refreshedSelections)
  }

  static buildAsiaTeaserBetSelectionPayload(oddsSelections, oddsFormat, teaserId, ticketId) {
    let legs = [];
    _.forEach(oddsSelections, sel => {
        legs.push({
          legId: sel.legId,
          selectionId: sel.selection
        })
    })

    const params = {
      teaserId: teaserId,
      ticketId: uuid(), // ticketId || uuid(),
      oddsFormat: oddsFormat,
      legs: JSON.stringify(legs)
    }

    return params;
  }

  static buildAsiaParlayBetSelectionPayload(oddsSelections, oddsFormat, ticketId) {
    let parlayOddsSelections = oddsSelections.map(sel => {
      return {
        legId: sel.legId,
        selectionId: sel.selection
      }
    })

    return {
      parlayOddsRequest: {
        oddsFormat: oddsFormat,
        parlayOddsSelections: parlayOddsSelections,
        ticketId: ticketId ? ticketId : uuid()
      }
    }
  }

  static removePitchersFromCookies() {
    cookie.remove('asiaPitchers', { path: "/", domain: Utils.getSubDomain() });
  }

  static loadPitchersFromCookies() {
    let pitchers = []
    if (cookie.load('asiaPitchers')) {
      pitchers = JSON.parse(Base64.decode(cookie.load('asiaPitchers')))
    }

    return pitchers
  }

  static savePitchersToCookies = (pitchers) => {
    Utils.saveCookie('asiaPitchers', Base64.encode(JSON.stringify(pitchers)), { path: "/", domain: Utils.getSubDomain() })
  }

  static showToastAfterPendingBetAccepted(betItems, translate, onClickToastLink) {
    _.forEach(betItems, (bet, index) => {
      let betType = bet[WagerMyBetMap.betType], selection = bet[WagerMyBetMap.selection]
      let status = bet[WagerMyBetMap.status]
      const isOutright = (betType === BetType.OUTRIGHT || betType === BetType.SPECIALS);

      let messages = [], toastClass = '', onClickToast = null;
      if (status === Constants.WAGER_STATUS.OPEN) {
        messages.push(Constants.TOAST.ACCEPTED_BET_MESSAGE);
        toastClass = Constants.TOAST.TOAST_CLASS_ACTIVE;
        onClickToast = onClickToastLink
      } else if (status === Constants.WAGER_STATUS.CANCELLED) {
        messages.push(Constants.TOAST.UNACCEPTED_BET_MESSAGE);
        toastClass = Constants.TOAST.TOAST_CLASS_ERROR;
      }

      if (isOutright) {
        selection = bet[WagerMyBetMap.outrightSelection]
        let handicap = bet[WagerMyBetMap.handicap] ? Utils.formatHandicapNumber(BetType.OUTRIGHT, bet[WagerMyBetMap.handicap]) : ''
        let unit = bet[WagerMyBetMap.unit] ? (' ' + bet[WagerMyBetMap.unit]) : ''
        let outrightSelection = selection + ' ' + handicap + unit
        messages.push(outrightSelection)
      } else if(betType === BetType.MIX_PARLAY) {
        selection = bet[WagerMyBetMap.selection]
        const handicap = bet[WagerMyBetMap.handicap] ? Utils.formatHandicapNumber(BetType.MIX_PARLAY, bet[WagerMyBetMap.handicap]) : ''
        const unit = ` ${bet[WagerMyBetMap.unit] || ''}`
        const parlaySelection = `${selection} ${handicap}${unit}`;
        messages.push(parlaySelection)
      } else {
        let sportId = bet[WagerMyBetMap.sportId]
        let sportGroup = (_.invert(SportGroup)[bet[WagerMyBetMap.sportGroup]])
        let periodNum = bet[WagerMyBetMap.periodNum]
        const periodTxt = BetslipAction.getPeriodDescription(sportId, periodNum, translate);
        let betTypeTxt = translate(sportGroup.toLowerCase() + ':' + (_.invert(BetType))[betType]);
        messages.push(selection);
        messages.push(periodTxt + ' - ' + betTypeTxt);
      }

      ToastGeneratorAction.generateToast({messages: messages, className: toastClass, tapOnLinkAction: onClickToast});
    })
  }
    // Update odds change follow the odds format
    static updateOddsByOddsFormat(oddsFormat, selections, responseSelections, isParlay) {
      const selectionsHasOddsChange = BetslipAction.getSelectionsHasOddsChange(responseSelections);
      if (selectionsHasOddsChange.length > 0 && selections.length > 0) {
        responseSelections.forEach(item => {
          const selectionIndex = selections.findIndex(selection => isParlay ? selection.legId === item.legId : (selection.id === item.oddsId));
          if (selectionIndex < 0) return;
          this.BetslipStore.updateSelectionOdds(BetslipAction.convertOddsByOddsFormat(selections[selectionIndex].odds, this.SportsStore.previousOddsFormat, oddsFormat), selectionIndex);
        });
      }
      this.SportsStore.updatePreviousOddsFormat(oddsFormat);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/BetslipComponent/AsiaView/MbAsiaBetslipActions.js